import React, { useContext } from 'react'
import PropType from 'prop-types'
import cx from 'classnames'

import Font from '@cred/react-font'
import { ThemeContext } from '@cred/react-theme'

import { fireGtmEvent } from 'utils/gtm'
import { getMetaQuery } from 'utils/data'
import CtaButton from 'components/cta-button'
import useMaxCTALengthWarning from 'components/hooks/useMaxCTALengthWarning'
import WidgetContext from 'components/widget-context'

import styles from './styles.module.scss'

const showPaidAdvertisement = (theme) => ['nypost', 'fox1', 'forbes1', 'insider'].includes(theme)

const SimpleCta = ({
  url,
  variation,
  customCTA,
  variations,
  utms,
  large,
  nmls,
  onClickHandle,
  metaParams,
  verticals,
  type,
  theme,
  uniqueId,
}) => {
  const widgetContext = useContext(WidgetContext)
  const queryString = Object.keys(utms)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(utms[k])}`)
    .join('&')
  const metaQuery = getMetaQuery({ ...metaParams, marketplace: verticals, type }, theme)
  const href = `${url}?${queryString}${metaQuery}`
  const className = large ? styles.large : styles.small

  useMaxCTALengthWarning({ customCTA, large, uniqueId })

  const themeFromProvider = useContext(ThemeContext)

  return (
    <div className={styles.wrapper}>
      <CtaButton
        href={href}
        className={cx(className, {
          [styles.truncated]: customCTA,
        })}
        onClick={onClickHandle(widgetContext)}
        blank
      >
        {customCTA || variations[variation]}
      </CtaButton>
      {nmls && (
        <div className={styles.copiesWrapper}>
          <Font className={styles.cred}>
            {showPaidAdvertisement(themeFromProvider)
              ? 'Paid Advertisement. Credible Operations, Inc. NMLS # 1681276'
              : 'Credible Operations, Inc. NMLS # 1681276'}
          </Font>
        </div>
      )}
    </div>
  )
}

const onClickHandleDefault = (widgetContext) => () => {
  fireGtmEvent('ctaClick', widgetContext)
}

SimpleCta.propTypes = {
  url: PropType.string.isRequired,
  variation: PropType.string.isRequired,
  uniqueId: PropType.string,
  customCTA: PropType.string,
  variations: PropType.object,
  utms: PropType.object.isRequired,
  large: PropType.bool,
  nmls: PropType.bool,
  onClickHandle: PropType.func,
  metaParams: PropType.object,
  verticals: PropType.array,
  type: PropType.string,
  theme: PropType.string,
}

SimpleCta.defaultProps = {
  large: false,
  variations: {
    'compare-rates': 'Compare Rates',
    'find-my-rate': 'Find My Rate',
    'learn-more': 'Learn More',
  },
  uniqueId: null,
  customCTA: null,
  nmls: false,
  onClickHandle: onClickHandleDefault,
}

export { SimpleCta as SimpleCtaNoHOC, onClickHandleDefault as onClick }

export default SimpleCta
